import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useDispatch } from 'react-redux';
import { setAdminUser } from '../features/userSlice';

export default function Login() {
  const dispatch = useDispatch();
  const { login, isAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      const admin = await login(email, password);
      const token = localStorage.getItem('adminToken') || '';
      if (admin) {
        dispatch(setAdminUser({ ...admin, token }));
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen dark:bg-dark_bg_1 flex items-center justify-center p-4">
      <div className="w-full max-w-md dark:bg-dark_bg_2 rounded-xl p-8 shadow-lg">
        <h1 className="text-2xl font-semibold text-dark_text_1 mb-2">تسجيل الدخول</h1>
        <p className="text-sm text-dark_text_2 mb-6">سجّل الدخول للوصول إلى لوحة التحكم</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <input
            className="input"
            type="email"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            className="input"
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error ? <p className="text-red-400 text-sm">{error}</p> : null}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green_1 hover:bg-green_2 rounded-full py-3 text-white font-medium disabled:opacity-60"
          >
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>
      </div>
    </div>
  );
}